// extracted by mini-css-extract-plugin
export default {"faqHolder":"Faq_financement_faqHolder__-eSZn"};